import { render, staticRenderFns } from "./AddOntologyModal.vue?vue&type=template&id=b71a06a8"
import script from "./AddOntologyModal.vue?vue&type=script&lang=js"
export * from "./AddOntologyModal.vue?vue&type=script&lang=js"
import style0 from "./AddOntologyModal.vue?vue&type=style&index=0&id=b71a06a8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports